export default "__VITE_ASSET__fLk$tiwv__"